(function () {
  if (window.__jojoListingFadeInit) return;
  window.__jojoListingFadeInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function settle(el) {
    if (el.classList.contains('is-settled')) return;
    el.classList.add('is-settled');
    el.dispatchEvent(new CustomEvent('jojo:fade-settled', { bubbles: true }));
  }

  function activate(el) {
    if (el.classList.contains('is-in') || el.classList.contains('is-settled')) return;
    el.classList.add('is-in');

    if (reduceMotion) {
      settle(el);
      return;
    }

    var finished = false;

    function done(event) {
      if (finished) return;
      if (event && event.target !== el) return;
      finished = true;
      el.removeEventListener('animationend', done);
      settle(el);
    }

    el.addEventListener('animationend', done);
    window.setTimeout(function () {
      done();
    }, 1200);
  }

  function observe(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.jojo-fade-up, .jojo-fade-in');
    if (!nodes.length) return;

    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      nodes.forEach(activate);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activate(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0 }
    );

    nodes.forEach(function (el) {
      if (el.classList.contains('is-in') || el.classList.contains('is-settled')) return;
      if (waitingForCover(el)) return;
      observer.observe(el);
    });
  }

  function waitingForCover(el) {
    var root = el.closest('.jojo-campaign-round1');
    if (!root) return false;
    var cover = root.querySelector('[data-round1-cover]');
    if (!cover || cover.classList.contains('is-gone')) return false;
    if (cover.dataset.fadeCoverBound !== 'true') {
      cover.dataset.fadeCoverBound = 'true';
      var watcher = new MutationObserver(function () {
        if (!cover.classList.contains('is-gone')) return;
        watcher.disconnect();
        observe(root);
      });
      watcher.observe(cover, { attributes: true, attributeFilter: ['class'] });
    }
    return true;
  }

  function boot() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
